import { render } from "./SignupForm.vue?vue&type=template&id=1593f8f6"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=1593f8f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__